export default __webpack_public_path__ + "static/mETH-d00d44c24665b19b7aea93830f805485.svg";